import React from 'react';
import newres from '../assets/newres.png';
import findjob from '../assets/findjob.png';
import language from '../assets/language.png';
import ModernResources from './modern/ModernResources';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
const RESOURCES = [
  {
    img: findjob,
    title: 'Looking for jobs in Canada?',
    text: 'Learn about job search skills, how to get a job, workplace standards and Canadian workplace culture.',
    href: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/settle-canada/job-search.html',
  },
  {
    img: language,
    title: 'Improve your English or French',
    text: 'Language skills help you settle and find work. Free classes are available in most communities across Canada.',
    href: 'https://www.canada.ca/en/immigration-refugees-citizenship/services/settle-canada/language-skills.html',
  },
  {
    img: newres,
    title: 'Find free newcomer services near you',
    text: 'Friendly and experienced settlement professionals can help you get started in Canada.',
    href: 'https://ircc.canada.ca/english/newcomers/services/index.asp',
  },
];

export default function Resources() {
  return <ModernResources items={RESOURCES} />;
}
